import { render, staticRenderFns } from "./profile-section.vue?vue&type=template&id=6595cd37&"
import script from "./profile-section.vue?vue&type=script&setup=true&lang=js&"
export * from "./profile-section.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./profile-section.vue?vue&type=style&index=0&id=6595cd37&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports